import axios from '@/utils/axios';
import urlConfig from '@/utils/urlConfig';


export default {

  /**
   *  五级行政区划级联查询
   * @param {*} data 
   * @returns 
   */

  fiveCascadeQuery: (data) => axios.apiPost(urlConfig.busiURL + `/scfs/communal/data/fiveCascadeQuery`, data),
  bankCodeQuery: (data) => axios.apiPost(urlConfig.busiURL + `/bank/code/getBankName?bankName=` + data, {},true),

  // 获取配置
  findConfigApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/configparam/getMapList', data),
  //刷新配置
  refreshConfigApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/configparam/refreshCache', data),

  //分页查询来账白名单
  findIncomeWhitePageApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/incoming/whitelist/page?pageNo='+data.pageNo+'&pageSize='+data.pageSize, data),
  //查询所有来账白名单
  findAllIncomeWhiteListApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/incoming/whitelist/list', data),
 //查询所有并按照label分组
  findIncomeWhiteListByLabelApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/incoming/whitelist/listGrouped', data),
  // 新增来账白名单
  addIncomeWhiteListApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/incoming/whitelist/add', data),
  // 修改来账白名单
  updateIncomeWhiteListApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/incoming/whitelist/update', data),
  // 删除来账白名单
  deleteIncomeWhiteListApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/incoming/whitelist/delete', data),

  // 分页查询客户经理信息表
  findCustomerManagerPageApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/customer/manager/page?pageNo='+data.pageNo+'&pageSize='+data.pageSize, data),
  // 查询所有客户经理信息表
  findAllCustomerManagerListApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/customer/manager/list', data),
  // 新增客户经理信息表
  addCustomerManagerApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/customer/manager/add', data),
  // 修改客户经理信息表
  updateCustomerManagerApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/customer/manager/update', data),
  // 删除客户经理信息表
  deleteCustomerManagerApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/customer/manager/delete', data),
  //通用文字统一识别 校验
  recognizeAllTextVerifyApi: (data) => axios.apiPost(urlConfig.busiURL + '/base/ocr/recognizeAllTextVerify', data),



};
 